// Make functions available globally for inline scripts
window.submitNotification = function submitNotification(event, message) {
  popupNotification(message);
  event.preventDefault();
}

window.submitAlert = function submitAlert(event, message) {
  popupAlert(message);
  event.preventDefault();
}

window.enableAutocomplete = function enableAutocomplete(fields) {
  $(fields).each(function () {
    $(this).autocomplete({
      source: $(this).data("autocomplete-source"),
      search: function (e, ui) {
        $(this).data("ui-autocomplete").menu.bindings = $();
      },
    });
  });
}

window.addIndustryTag = function addIndustryTag(industry, field, insert_before, search) {
  var value = industry.trim();

  if (value.length > 0) {
    $(field).val($(field).val() + "]ind=[" + value);
    var tag = loadIndustryTags(value, insert_before);
    $(search).val("");
    removeIndustryTag($(tag).find("i.remove_tag"), field);
  } else {
    $(search).val("");
  }
}

window.loadIndustryTags = function loadIndustryTags(industry, insert_before) {
  var tag = $(
    '<span class="tag_item">' +
      industry +
      '<i class="remove_tag fa fa-times"></i></span>'
  );
  $(tag).insertBefore($(insert_before));
  return tag;
}

window.removeIndustryTag = function removeIndustryTag(selector, field) {
  $(selector).click({ field: field }, function (e) {
    var tag = $(this).closest("span.tag_item");
    list = $(e.data.field)
      .val()
      .replace("]ind=[" + tag.text(), "");
    $(e.data.field).val(list);
    $(tag).remove();
  });
}

window.inlineValidationNotice = function inlineValidationNotice(selector, message, success) {
  if (success) {
    $(selector).css("color", "#8ac34b");
  } else {
    $(selector).css("color", "#f44336");
  }

  $(selector).text(message);
  $(selector).fadeIn();
}

window.cursorStyle = function cursorStyle(style) {
  document.body.style.cursor = style;
}

window.disableEnterKeySubmission = function disableEnterKeySubmission() {
  $("form").on("keypress", function (e) {
    if (e.keyCode === 13) {
      return false;
    }
  });
}

$.expr[":"].Contains = function (a, i, m) {
  return $(a).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
};

window.tab_or_newline = function tab_or_newline(field, insertion, event) {
  var start = field.selectionStart;
  var end = field.selectionEnd;
  var $field = $(field);
  var value = $field.val();
  $field.val(value.substring(0, start) + insertion + value.substring(end));
  field.selectionStart = field.selectionEnd = start + 1;
  event.preventDefault();
}

window.getFieldValues = function getFieldValues(selector) {
  var fields = $(selector)
    .map(function () {
      return $(this).val();
    })
    .get();

  return fields;
}

window.checkRequiredFilled = function checkRequiredFilled(selectors) {
  var fields = selectors
    .map(function () {
      return $.trim($(this).val());
    })
    .get();

  return !fields.includes("");
}

window.mapParametersAsJson = function mapParametersAsJson(fields) {
  var params_hash = "{";

  fields.each(function (index) {
    if ($(this).attr("type") === "checkbox") {
      if (index > 0) {
        params_hash += ",";
      }
      params_hash +=
        '"' + $(this).attr("name") + '": "' + $(this).is(":checked") + '"';
    } else if ($(this).attr("type") === "radio") {
      if ($(this).is(":checked")) {
        params_hash +=
          '"' + $(this).attr("name") + '": "' + $(this).val() + '"';
      }
    } else {
      if (index > 0) {
        params_hash += ",";
      }
      params_hash +=
        '"' + $(this).attr("name") + '": ' + JSON.stringify($(this).val()) + "";
    }
  });

  return JSON.parse(params_hash + "}");
}

// Type: Photo Uploaders //
window.bindPhotoPlaceholder = function bindPhotoPlaceholder(placeholder) {
  $(placeholder).each(function () {
    var holder = this;

    $($(this).attr("data-target")).on("change", function () {
      displayPhotoPlaceholder(holder, this);
    });

    if ($($(this).attr("data-target")).val().length > 0) {
      displayPhotoPlaceholder(holder, $(this).attr("data-target"));
    }
  });
}

// Photo Placeholder that updates when a photo field is changed.
window.displayPhotoPlaceholder = function displayPhotoPlaceholder(holder, field) {
  if (typeof FileReader !== "undefined" && $(field)[0].files[0] !== undefined) {
    var image_holder = $(holder);
    image_holder.empty();
    var reader = new FileReader();

    reader.onload = function (event) {
      $("<img/>", { src: event.target.result }).appendTo(image_holder);
    };

    reader.readAsDataURL($(field)[0].files[0]);
  }
}

window.photoUploadButton = function photoUploadButton(button) {
  $(button).click(function () {
    $($(this).attr("data-target")).click();
  });
}
